import { createModel } from "@rematch/core";
import { Dispatch } from "redux";
import { KoreModel } from "./";
import axios from "axios";

export interface PinnedApp {
  id: string | number;
  type: number;
}

export interface DesktopConfigs {
  theme: string;
  pinnedApps: PinnedApp[];
  locked: boolean;
  idLayout: number | string;
  dense: boolean;
  hideTabs: boolean;
}

const model = {
  name: "desktopConfigs",
  state: {} as DesktopConfigs,
  reducers: {
    updateData: (currentState: DesktopConfigs, { name, value, save = true }: { name: string; value: unknown; save?: boolean }) => {
      const newConfigs = { ...currentState, [name]: value };

      if (save) axios.post("Desktop/setDesktopConfigurations", newConfigs);

      return newConfigs;
    },
    setData: (currentState: DesktopConfigs, data: DesktopConfigs) => {
      return { ...data };
    }
  },
  effects: (dispatch: Dispatch) => {
    return {
      async getData() {
        const { data } = await axios.get("/Desktop/getDesktopConfigurations");

        if (data) dispatch.desktopConfigs.setData(data);

        return data;
      }
    };
  }
};

export const desktopConfigsModel = createModel<KoreModel>()(model);
